import { FlightList } from "./FlightList";
import { FlightInformation } from "./FlightInformation";
import {useState} from 'react';
import { FlightProps } from "./FlightProps";
import { FlightListInfo } from "./FlightListInfo";
import { Text } from "@mantine/core";

interface FlightsProps {
    updateShowFlightList: (arg: any) => void,
    flights : any,
    value: string ,
    showFlightList : boolean,
    performSearch: () => void,
    isDarkTheme: boolean,
    updateShowSessionError: (arg: boolean) => void,
    noSearchResults: boolean
}

export const Flights = (props: FlightsProps) => {
    const updateSelectedFlight = (newSelectedFlight: FlightProps):void => {
        setSelectedFlight(newSelectedFlight);
        props.updateShowFlightList(false);
    }
    
    const [selectedFlight, setSelectedFlight] = useState<FlightProps>({callsign: '', flightPlanId: '', targetId: '', properties: {callsign: '',
                                                                                                      auto_aircraft_id_field_name: '',
                                                                                                      auto_aircraft_id_iata_field_name: '',
                                                                                                      assigned_gate_aerobahn_field_name: '',
                                                                                                      direction_field_name: '',
                                                                                                      preliminary_off_block_time_aerobahn_field_name: '',
                                                                                                      target_startup_approval_time_acdm: '',
                                                                                                      edct_aerobahn: '',
                                                                                                      target_off_block_time_aerobahn_field_name: '',
                                                                                                      assigned_gate_aerobahn_field_name_short: '',
                                                                                                      dest_airport_field_name: '',
                                                                                                      preliminary_startup_approval_time_field_name:'',
                                                                                                      tail_number_field_name: '',
                                                                                                  }, performSearch(){},updateShowSessionError(){}});
    return (
      <div>
        { props.showFlightList ?     
          <div>
            <FlightList updateSelectedFlight={updateSelectedFlight} flights={props.flights} isDarkTheme={props.isDarkTheme}></FlightList>
            { !props.value || props.value == '' ?
              <FlightListInfo isDarkTheme={props.isDarkTheme}></FlightListInfo>
            : null }
            { props.noSearchResults && !(props.flights.length > 0) && props.value != '' ?
              <Text color={props.isDarkTheme ? 'white' : 'black'} style={{display:'block', margin:'20px auto', padding:'10px', listStyleType:'decimal'}}>
                <strong>No search results found for {props.value}</strong>
              </Text> 
            : null }
          </div> 
        : null }
        { !props.showFlightList ?            
          <FlightInformation callsign={selectedFlight.properties.auto_aircraft_id_field_name} flightPlanId={selectedFlight.flightPlanId} targetId={selectedFlight.targetId} properties={selectedFlight.properties} performSearch={props.performSearch} updateShowSessionError={props.updateShowSessionError}></FlightInformation> 
        : null }
      </div>
    );
}

